import React from 'react';

const PlusIcon: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 24C14 24.5523 14.4477 25 15 25C15.5523 25 16 24.5523 16 24V16H24C24.5523 16 25 15.5523 25 15C25 14.4477 24.5523 14 24 14H16V6C16 5.44772 15.5523 5 15 5C14.4477 5 14 5.44772 14 6V14H6C5.44772 14 5 14.4477 5 15C5 15.5523 5.44772 16 6 16H14V24Z"
        fill="black"
      />
    </svg>
  );
};

export default PlusIcon;
